var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PageLogin',{attrs:{"namePage":"login-profissional","title":"Login do profissional","subtitle":"Entre com um e-mail e senha do profissional","profissional":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }